import { render, staticRenderFns } from "./EmployeeApprovalsFiles.vue?vue&type=template&id=63fd2dea&"
import script from "./EmployeeApprovalsFiles.vue?vue&type=script&lang=ts&"
export * from "./EmployeeApprovalsFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports